export default __webpack_public_path__ + "static/media/Ghana.de466d7e.png";